import { render, staticRenderFns } from "./NeoparentCreateNurse.vue?vue&type=template&id=366da738&scoped=true"
import script from "./NeoparentCreateNurse.vue?vue&type=script&lang=js"
export * from "./NeoparentCreateNurse.vue?vue&type=script&lang=js"
import style0 from "./NeoparentCreateNurse.vue?vue&type=style&index=0&id=366da738&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "366da738",
  null
  
)

export default component.exports